import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import UserList from './Pages/UserList';
import RolesAndPermissions from './Pages/RolesAndPermissionsPage';
import PermissionsEditor from './Pages/PermissionsEditor';
import AdminStore from './Stores/AdminStore';
import './AdminPanel.css';

const AdminPanel = observer(() => {
  const adminStore = useMemo(() => new AdminStore(), []);

  const renderContent = () => {
    switch (adminStore.selectedTab) {
      case 'users':
        return <UserList adminStore={adminStore} />;
      case 'roles':
        return <RolesAndPermissions adminStore={adminStore} />;
      case 'permissions':
        return <PermissionsEditor adminStore={adminStore} />;
      default:
        return null;
    }
  };

  return (
    <div className="admin-panel">
      <div className="admin-body">
        <aside className="admin-sidebar">
          <ul>
            <li
              className={adminStore.selectedTab === 'users' ? 'active' : ''}
              onClick={() => adminStore.setSelectedTab('users')}
            >
              Пользователи
            </li>
            <li
              className={adminStore.selectedTab === 'roles' ? 'active' : ''}
              onClick={() => adminStore.setSelectedTab('roles')}
            >
              Роли и Права
            </li>
            <li
              className={adminStore.selectedTab === 'permissions' ? 'active' : ''}
              onClick={() => adminStore.setSelectedTab('permissions')}
            >
              Редактор прав
            </li>
          </ul>
        </aside>
        <main className="admin-content">
          {renderContent()}
        </main>
      </div>
    </div>
  );
});

export default AdminPanel;
